(function () {
  var CSS = [
    '.product-faq-accordion{margin-top:1em;border-top:1px solid rgba(0,0,0,0.12);}',
    '.product-faq-item{border-bottom:1px solid rgba(0,0,0,0.12);}',
    '.product-faq-item > summary{cursor:pointer;padding:0.9em 1.75em 0.9em 0;font-weight:600;position:relative;list-style:none;}',
    '.product-faq-item > summary::-webkit-details-marker{display:none;}',
    '.product-faq-item > summary::marker{content:"";}',
    '.product-faq-item > summary::after{content:"+";position:absolute;right:0.15em;top:0.8em;font-weight:400;font-size:1.25em;line-height:1;}',
    '.product-faq-item[open] > summary::after{content:"\2212";}',
    '.product-faq-item .product-faq-answer{padding:0 0 1.1em;}',
    '.product-faq-answer p:first-child,.product-faq-answer ul:first-child{margin-top:0;}',
    '.product-faq-answer p:last-child,.product-faq-answer ul:last-child{margin-bottom:0;}',
    '.product-description-item{border-top:1px solid rgba(0,0,0,0.12);}'
  ].join('');

  var SECTION_MIN_CHARS = 220;

  function injectStyle() {
    if (document.getElementById('product-faq-accordion-style')) return;
    var style = document.createElement('style');
    style.id = 'product-faq-accordion-style';
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function stripLeadingPunctuation(html) {
    return html.replace(/^[\s:–—-]+/, '').trim();
  }

  function textLengthOf(nodes) {
    return nodes.reduce(function (sum, n) {
      return sum + (n.textContent || '').trim().length;
    }, 0);
  }

  function buildDescriptionAccordion(container, firstHeading) {
    var nodes = [];
    var node = container.firstElementChild;
    while (node && node !== firstHeading) {
      nodes.push(node);
      node = node.nextElementSibling;
    }
    if (!nodes.length) return;

    var visible = nodes.slice(0, 1);
    var rest = nodes.slice(1);
    if (!rest.length || textLengthOf(rest) < SECTION_MIN_CHARS) return;

    injectStyle();

    var details = document.createElement('details');
    details.className = 'product-faq-item product-description-item';

    var summary = document.createElement('summary');
    summary.className = 'product-faq-question';
    summary.textContent = 'Read more';

    var answer = document.createElement('div');
    answer.className = 'product-faq-answer';
    rest.forEach(function (n) { answer.appendChild(n); });

    details.appendChild(summary);
    details.appendChild(answer);
    container.insertBefore(details, firstHeading || null);
  }

  function buildFaqAccordion(heading) {
    var items = [];
    var node = heading.nextElementSibling;
    while (node && !/^H[1-6]$/.test(node.tagName)) {
      var next = node.nextElementSibling;
      if (node.tagName === 'P') {
        var strong = node.querySelector('strong, b');
        if (strong && strong.textContent.trim()) {
          var question = strong.textContent.trim().replace(/[:\s]+$/, '');
          var clone = node.cloneNode(true);
          var strongInClone = clone.querySelector('strong, b');
          if (strongInClone) strongInClone.remove();
          var answerHtml = stripLeadingPunctuation(clone.innerHTML);
          if (answerHtml) {
            items.push({ question: question, answerHtml: answerHtml, original: node });
          }
        }
      }
      node = next;
    }

    if (!items.length) return;

    injectStyle();

    var wrapper = document.createElement('div');
    wrapper.className = 'product-faq-accordion';

    items.forEach(function (item) {
      var details = document.createElement('details');
      details.className = 'product-faq-item';

      var summary = document.createElement('summary');
      summary.className = 'product-faq-question';
      summary.textContent = item.question;

      var answer = document.createElement('div');
      answer.className = 'product-faq-answer';
      answer.innerHTML = item.answerHtml;

      details.appendChild(summary);
      details.appendChild(answer);
      wrapper.appendChild(details);
      item.original.remove();
    });

    heading.insertAdjacentElement('afterend', wrapper);
  }

  function buildNamedSectionAccordion(heading) {
    var nodes = [];
    var node = heading.nextElementSibling;
    while (node && !/^H[1-6]$/.test(node.tagName)) {
      var next = node.nextElementSibling;
      nodes.push(node);
      node = next;
    }
    if (!nodes.length || textLengthOf(nodes) < SECTION_MIN_CHARS) return;

    injectStyle();

    var details = document.createElement('details');
    details.className = 'product-faq-item product-named-section-item';

    var summary = document.createElement('summary');
    summary.className = 'product-faq-question';
    summary.textContent = heading.textContent.trim();

    var answer = document.createElement('div');
    answer.className = 'product-faq-answer';
    nodes.forEach(function (n) { answer.appendChild(n); });

    details.appendChild(summary);
    details.appendChild(answer);
    heading.insertAdjacentElement('afterend', details);
    heading.remove();
  }

  function initProductAccordions(container) {
    if (!container || container.dataset.faqAccordionInit) return;

    var headings = [];
    var found = container.querySelectorAll('h1, h2, h3, h4');
    for (var i = 0; i < found.length; i++) headings.push(found[i]);

    buildDescriptionAccordion(container, headings[0] || null);

    headings.forEach(function (heading) {
      if (/faq/i.test(heading.textContent)) {
        buildFaqAccordion(heading);
      } else {
        buildNamedSectionAccordion(heading);
      }
    });

    container.dataset.faqAccordionInit = 'true';
  }

  function run() {
    var containers = document.querySelectorAll('[data-product-description], [data-product-readmore]');
    for (var i = 0; i < containers.length; i++) {
      initProductAccordions(containers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
